import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import NewsletterService from "@/integrations/service/newsletter.service";
import { toast } from "sonner";
import axios from "axios";

export const useSubscribeNewsletter = () => {
  return useMutation({
    mutationFn: NewsletterService.subscribe,
  });
};

export const useUnsubscribeNewsletter = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: NewsletterService.unsubscribe,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["newsletter-abonnes"] });
    },
    onError: (err) => {
      if (axios.isAxiosError(err)) {
        const status = err.response?.status;
        if (status === 404) {
          toast.error("Cet email n'est pas inscrit.");
        } else {
          toast.error("Erreur lors du désabonnement.");
        }
      }
    },
  });
};

export const useNewsletterAbonnes = (actif = true) => {
  return useQuery({
    queryKey: ["newsletter-abonnes", actif],
    queryFn: () => NewsletterService.list(actif),
  });
};

export const useDeclencherDigestHebdomadaire = () => {
  return useMutation({
    mutationFn: NewsletterService.declencherDigestHebdomadaire,
  });
};
